import React from 'react'

import { useParams } from 'react-router-dom'
import { IconButton } from '@mui/material'
import { Edit as EditIcon } from '@mui/icons-material'

import { useSearchParams } from '@edge/spark/utils'
import { DashboardNameDialog, type Props as DashboardNameDialogProps } from '../DashboardNameDialog'

import { useChangeDashboardNameMutation } from '@edge/spark/io-dashboards'

interface DashboardButtonProps {
    initialValue?: string
    onSubmit?: () => void
    className?: string
}

export const EditDashboardNameButton: React.FC<DashboardButtonProps> = ({
    initialValue,
    onSubmit,
    className,
}: DashboardButtonProps) => {
    const [open, setOpen] = React.useState(false)
    const [changeName] = useChangeDashboardNameMutation()
    const { uid: userId } = useSearchParams()
    const { dashId } = useParams<{ dashId?: string }>()

    const handleClose = (): void => setOpen(false)
    const handleClickOpen = (): void => setOpen(true)
    const handleSubmit: DashboardNameDialogProps['onSubmit'] = ({ name }): void => {
        changeName({ variables: { name, dashId, userId } })
        onSubmit?.()
        handleClose()
    }

    return (
        <>
            <IconButton className={className} size="small" color="secondary" onClick={handleClickOpen}>
                <EditIcon />
            </IconButton>
            {open && <DashboardNameDialog initialValue={initialValue} onClose={handleClose} onSubmit={handleSubmit} />}
        </>
    )
}
